// Import model
import { OtgCatalogManufacturerCondition } from '../models/OtgCatalogManufacturerCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { OtgCatalogManufacturerIndexedFields } from '../models/OtgCatalogManufacturerIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { OtgCatalogManufacturerIndexedFieldsSerializer } from './OtgCatalogManufacturerIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for OtgCatalogManufacturerCondition - handles JSON serialization and deserialization with type validation
 */
export class OtgCatalogManufacturerConditionSerializer {
  /**
   * Deserializes a JSON string into a OtgCatalogManufacturerCondition instance
   */
  static deserialize(json: string): OtgCatalogManufacturerCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a OtgCatalogManufacturerCondition instance
   */
  static fromObject(obj: any): OtgCatalogManufacturerCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to OtgCatalogManufacturerCondition');
    }


    const instance: OtgCatalogManufacturerCondition = {
      fieldName: obj['fieldName'] as OtgCatalogManufacturerIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of OtgCatalogManufacturerCondition instances
   */
  static deserializeArray(json: string): OtgCatalogManufacturerCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a OtgCatalogManufacturerCondition instance to a JSON string
   */
  static serialize(instance: OtgCatalogManufacturerCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a OtgCatalogManufacturerCondition instance to a plain object
   */
  static toObject(instance: OtgCatalogManufacturerCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of OtgCatalogManufacturerCondition instances to a JSON string
   */
  static serializeArray(instances: OtgCatalogManufacturerCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
